import { useEffect } from "react";

/**
 * Inject a JSON-LD schema.org `<script>` into the document head.
 *
 * - `id`   stable DOM id so we replace any prior tag with the same id when the
 *          page's data changes (prevents stale schema during SPA navigation).
 * - `data` plain JS object that will be JSON.stringified.
 *
 * Googlebot now renders JavaScript before extracting structured data, so this
 * client-injected schema is read by Search, Google News, and AI summarizers
 * exactly like a server-rendered tag.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    try {
      el.textContent = JSON.stringify(data);
    } catch {
      // Defensive — should never happen with the shapes we pass.
    }
    return () => {
      // Leave the tag in place across SPA navigations so the next render can
      // mutate it in place. Only remove on full unmount of the producer.
    };
  }, [id, data]);
  return null;
}
